import React, { useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";

import WarningIcon from "../../assets/images/warningEditTime.svg";

import { hours, minutes } from "../../data";

import Select from "react-select";

const DailyLogsEditTime = () => {
  const { editTime, setEditTime, setSuccess } = useStateContext();

  const [details, setDetails] = useState({
    inTimeHours: "",
    inTimeMinues: "",
    outTimeHours: "",
    outTimeMinutes: "",
  });

  const handleSelect = (e, name) => {
    setDetails({
      ...details,
      [name]: e,
    });
  };

  return (
    <>
      <div
        className={`${
          editTime ? "applyLeaveModal visible" : "applyLeaveModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <div className="flex mb-5">
              <div className="heading ">
                <span>Edit Time</span>
              </div>
              <div className="warning">
                <span className="icon">
                  <img src={WarningIcon} alt="" />
                </span>
                <span>You can update this only 3 times Monthly!</span>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label2 mb-3">
                Choose IN TIME
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <label htmlFor="leaveType" className="form-label">
                    Select Hour
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={hours}
                    onChange={(e) => {
                      handleSelect(e, "inTimeHours");
                    }}
                    value={details.inTimeHours}
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="leaveType" className="form-label">
                    Select Minutes
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={minutes}
                    onChange={(e) => {
                      handleSelect(e, "inTimeMinues");
                    }}
                    value={details.inTimeMinues}
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label2 mb-3">
                Choose OUT TIME
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <label htmlFor="leaveType" className="form-label">
                    Select Hour
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={hours}
                    onChange={(e) => {
                      handleSelect(e, "outTimeHours");
                    }}
                    value={details.outTimeHours}
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="leaveType" className="form-label">
                    Select Minutes
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={minutes}
                    onChange={(e) => {
                      handleSelect(e, "outTimeMinutes");
                    }}
                    value={details.outTimeMinutes}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-reset">Cancel</button>
            <button
              className="btn btn-apply"
              onClick={(e) => {
                setEditTime(false);
                setSuccess(true);
              }}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DailyLogsEditTime;
